import { useRef, useState } from 'react';

const usePlayMobileAndTabletVideo = (timeOut: number = 1000) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [paused, setPause] = useState<boolean>(true);
  const [showButton, setShowButton] = useState<boolean>(true);

  const onPlay = () => {
    if (!videoRef.current) return;
    setPause(!paused);
    if (paused) {
      const unsub = setTimeout(() => {
        setShowButton(false);
        clearTimeout(unsub);
      }, timeOut);
      void videoRef.current.play();
    } else {
      setShowButton(true);
      videoRef.current.pause();
    }
    videoRef.current.muted = !videoRef.current.muted;
  };

  return { videoRef, onPlay, paused, showButton };
};

export default usePlayMobileAndTabletVideo;
